// extracted by mini-css-extract-plugin
export default {"root":"KyvAKUnvR8JqkbMyRFQ4","fieldset":"LeQfbMe2jK2WIC4mWgoY","legend":"mwDO94xA3ptMFcYNnLip","placeHolderShimmer":"NHJxBBzgVgQMbxK0Q66y"};